<div class="settings-container">
    <h2 class="section-title">Settings</h2>

    <mat-card class="settings-card">
        <mat-card-header>
            <mat-card-title>Appearance</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="setting-row">
                <div class="setting-label">
                    <span>Dark Mode</span>
                    <p class="description">画面を暗い配色に切り替えます。</p>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="isDarkMode" (change)="toggleTheme()">
                </mat-slide-toggle>
            </div>
        </mat-card-content>
    </mat-card>

    <mat-card class="settings-card">
        <mat-card-header>
            <mat-card-title>Display Settings</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p class="description">デフォルトの表示件数を設定します。</p>
            <mat-form-field appearance="outline">
                <mat-label>Default Rows per Page</mat-label>
                <mat-select [(value)]="defaultPageSize" (selectionChange)="savePageSize()">
                    <mat-option [value]="25">25 rows</mat-option>
                    <mat-option [value]="50">50 rows</mat-option>
                    <mat-option [value]="100">100 rows</mat-option>
                    <mat-option [value]="250">250 rows</mat-option>
                    <mat-option [value]="500">500 rows</mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card-content>
    </mat-card>
</div>